import { BaseEvents } from '@/shared/utils';

export const TeacherEventKeys = {
  redirects: {
    to: 'redirects/to',
  },
  teachers: {
    view: 'teachers/view',
    do: 'teachers/do',
    doDetail: 'teachers/doDetail',
    success: 'teachers/success',
    error: 'teachers/error',
    search: {
      view: 'teachers/search/view',
      do: 'teachers/search/do',
      success: 'teachers/search/success',
      error: 'teachers/search/error',
    },
    filter: {
      view: 'teachers/filter/view',
      do: 'teachers/filter/do',
      success: 'teachers/filter/success',
      error: 'teachers/filter/error',
    },
    loadMore: {
      do: 'teachers/loadMore/do',
      success: 'teachers/loadMore/success',
      error: 'teachers/loadMore/error',
    },
  },
  teacher: {
    view: 'teacher/view',
    do: 'teacher/do',
    success: 'teacher/success',
    error: 'teacher/error',
  },
} as const;

export interface TeacherEvents extends BaseEvents {
  'teachers/view': void;
  'teachers/do': { query: string };
  'teachers/success': { results: any[] };
  'teachers/error': Error;
  'teachers/search/view': void;
  'teachers/search/do': { query: string };
  'teachers/search/success': { results: any[] };
  'teachers/search/error': Error;
  'teachers/filter/view': void;
  'teachers/filter/do': { filters: Record<string, any> };
  'teachers/filter/success': { filteredResults: any[] };
  'teachers/filter/error': Error;
  'teachers/loadMore/do': { currentPage: number };
  'teachers/loadMore/success': { additionalResults: any[] };
  'teachers/loadMore/error': Error;
  'teachers/doDetail': { id: string; displayName: string };
  'teacher/view': undefined;
  'teacher/do': { query: string };
  'teacher/success': { results: any[] };
  'teacher/error': Error;
  'redirects/to': { url: string; isExternalPage: boolean };
}
